import React from "react";
import { useState, useEffect } from 'react'
import { useLocation, useNavigate } from "react-router-dom";
import alarmSvg from '../assets/images/notification-bing-svgrepo-com.svg';
import settingsSvg from '../assets/images/circle-tick-svgrepo-com.svg';
import Notification from '../components/common/Notification';
import { GetList, GetListAsync } from '../providers/dataProvider';
import "../layouts/Header.scss";
import "../layouts/NavBar.scss";

const Header = () => {
     const location = useLocation();
     const navigate = useNavigate();
     const [unreadCount, setUnreadCount] = useState(0);
     const [pendingApprovalCount, setPendingApprovalCount] = useState(0);
     const [routeHeaderMeta, setRouteHeaderMeta] = useState(null);
         const refreshUnreadCount = () => {
             GetList("notificationunreadcount", {}, (res) => {
                 setUnreadCount(res?.data?.unreadCount || 0);
             });
         };

         const refreshPendingApprovalCount = async () => {
             try {
                 const result = await GetListAsync("quotationPending", {});
                 setPendingApprovalCount(Array.isArray(result?.data) ? result.data.length : 0);
             } catch {
                 setPendingApprovalCount(0);
             }
         };
     
         useEffect(() => {
             refreshUnreadCount();
             refreshPendingApprovalCount();

             const handleApprovalDone = () => refreshPendingApprovalCount();
             window.addEventListener("approvalStatusChanged", handleApprovalDone);
             return () => window.removeEventListener("approvalStatusChanged", handleApprovalDone);
         }, []);

         useEffect(() => {
             const handleHeaderMetaChange = (event) => {
                 const detail = event?.detail;
                 if (!detail?.pathname) return;

                 if (detail?.clear === true) {
                     setRouteHeaderMeta((currentValue) =>
                         currentValue?.pathname === detail.pathname ? null : currentValue
                     );
                     return;
                 }

                 setRouteHeaderMeta(detail);
             };

             window.addEventListener("pathfinderHeaderMetaChange", handleHeaderMetaChange);
             return () => window.removeEventListener("pathfinderHeaderMetaChange", handleHeaderMetaChange);
         }, []);
    const pageTitleMap = {
        "/dashboard": "Dashboard",
        "/quotation": "Quotations",
        "/quotation-general": "Sales / Quote Register",
        "/job-in-hand": "Sales / Quote Workspace",
        "/enquiry-list": "Sales / Enquiries",
        "/order-list": "Sales / Orders",
    };

    const activeHeaderMeta =
        routeHeaderMeta?.pathname === location.pathname ? routeHeaderMeta : null;
    const pageTitle = activeHeaderMeta?.title || pageTitleMap[location.pathname] || "PathFinder";
    const handleHeaderBack = () => {
        if (activeHeaderMeta?.backTarget?.pathname) {
            navigate(activeHeaderMeta.backTarget.pathname, {
                state: activeHeaderMeta.backTarget.state,
            });
            return;
        }

        navigate(-1);
    };

    return (
    <section id="Header">
        <div className="container-fluid">
            <div className="row">
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
                    <div className="card header-card">
                        <div className="card-body">
                            <div className="app-header-shell">
                                <div className={`app-header-title ${activeHeaderMeta ? "with-back" : ""}`}>
                                    {activeHeaderMeta?.backTarget && (
                                        <button
                                            type="button"
                                            className="app-header-back-btn"
                                            onClick={handleHeaderBack}
                                            title="Back"
                                            aria-label="Back"
                                        >
                                            <i className="fas fa-angle-left"></i>
                                        </button>
                                    )}
                                    <span>{pageTitle}</span>
                                </div>
                                <ul className="d-flex justify-content-end align-items-center mb-0">
                                    <li>
                                        <button
                                            className={`header-icon-btn ${unreadCount > 0 ? "has-work" : ""}`}
                                            type="button"
                                            data-toggle="modal"
                                            data-target="#notificationRightSideModalPopup"
                                            data-backdrop="false"
                                            title={unreadCount > 0 ? `${unreadCount} unread notification${unreadCount !== 1 ? "s" : ""}` : "Notifications"}
                                        >
                                            <img src={alarmSvg} alt='Alarm-Image' className='alarm-img'></img>
                                            {unreadCount > 0 && (
                                                <span className="badge">{unreadCount}</span>
                                            )}
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            className={`header-icon-btn ${pendingApprovalCount > 0 ? "has-work approval-work" : ""}`}
                                            type="button"
                                            title={pendingApprovalCount > 0 ? `${pendingApprovalCount} pending approval${pendingApprovalCount !== 1 ? "s" : ""}` : "Approvals"}
                                        >
                                            <img src={settingsSvg} alt='Settings-Image' className='settings-img'></img>
                                            {pendingApprovalCount > 0 && (
                                                <span className="badge">{pendingApprovalCount}</span>
                                            )}
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
                    <Notification onNotificationRead={refreshUnreadCount} />
      </section>
    );
};

export default Header;
